/**
 *  @class
 *  @function AntesDespues
 */
if (!customElements.get('antes-despues')) {
  class AntesDespues extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.antes-despues--slider');
      this.mediaBefore = this.querySelector('.antes-despues--1');
      this.mediaAfter = this.querySelector('.antes-despues--2');
      this.position = this.slider ? this.slider.value : 0;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            gsap.to(this, {
              '--percent': `${this.position / 10}%`,
              duration: 1.5,
              ease: 'power2.out',
            });
            this.observer.unobserve(this);
          }
        },
        {
          threshold: [0, 1],
          rootMargin: '0% 0% -20% 0%',
        }
      );
    }
    connectedCallback() {
      if (!this.slider) return;
      this.slider.addEventListener('input', this.onInput.bind(this));
      if (document.body.classList.contains('animations-true')) {
        this.style.setProperty('--percent', '0%');
        this.observer.observe(this);
      } else {
        this.style.setProperty('--percent', `${this.position / 10}%`);
      }
    }
    onInput() {
      this.style.setProperty('--percent', `${this.slider.value / 10}%`);
    }
  }
  customElements.define('antes-despues', AntesDespues);
}
